module.exports = __webpack_public_path__ + "media/semantic/dist/themes/default/assets/fonts/icons-a0369ea57eb6d3843d6474c035111f29.eot";